var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.answer.head
      ? _c("strong", { staticClass: "e-field-grid-label" }, [
          _vm._v(_vm._s(_vm.answer.head))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "e-field-grid-col m-sp-full",
        class: _vm.answer.has_other_field ? "m-has-other" : ""
      },
      [
        _c(
          "label",
          {
            staticClass: "m-inline m-required m-sp-block",
            class: _vm.inputFieldClass
          },
          [
            _vm.question.is_checkbox
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputStore.question[_vm.question.ordered],
                      expression: "inputStore.question[question.ordered]"
                    }
                  ],
                  ref: "checkElement",
                  staticClass: "e-input",
                  attrs: {
                    type: "checkbox",
                    name: "question[" + _vm.question.ordered + "]"
                  },
                  domProps: {
                    value: _vm.answer,
                    checked: Array.isArray(
                      _vm.inputStore.question[_vm.question.ordered]
                    )
                      ? _vm._i(
                          _vm.inputStore.question[_vm.question.ordered],
                          _vm.answer
                        ) > -1
                      : _vm.inputStore.question[_vm.question.ordered]
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.inputStore.question[_vm.question.ordered],
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = _vm.answer,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.inputStore.question,
                                _vm.question.ordered,
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.inputStore.question,
                                _vm.question.ordered,
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.inputStore.question,
                            _vm.question.ordered,
                            $$c
                          )
                        }
                      },
                      _vm.validateHandler
                    ]
                  }
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputStore.question[_vm.question.ordered],
                      expression: "inputStore.question[question.ordered]"
                    }
                  ],
                  ref: "checkElement",
                  staticClass: "e-input",
                  attrs: {
                    type: "radio",
                    name: "question[" + _vm.question.ordered + "]"
                  },
                  domProps: {
                    value: _vm.answer.label,
                    checked: _vm._q(
                      _vm.inputStore.question[_vm.question.ordered],
                      _vm.answer.label
                    )
                  },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(
                          _vm.inputStore.question,
                          _vm.question.ordered,
                          _vm.answer.label
                        )
                      },
                      _vm.validateHandler
                    ]
                  }
                }),
            _vm._v(" "),
            _c("span", { staticClass: "e-label" }, [
              _vm._v(_vm._s(_vm.answer.label))
            ])
          ]
        ),
        _vm._v(" "),
        _vm.answer.has_other_field
          ? _c("div", { staticClass: "e-other-field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value:
                      _vm.inputStore.question_other[_vm.question.ordered][
                        _vm.answer.ordered
                      ],
                    expression:
                      "\n                    inputStore.question_other[question.ordered][\n                        answer.ordered\n                    ]\n                "
                  }
                ],
                staticClass: "c-input-field-text m-pc-half",
                attrs: {
                  type: "text",
                  name: "question_other[" + _vm.question.ordered + "]"
                },
                domProps: {
                  value:
                    _vm.inputStore.question_other[_vm.question.ordered][
                      _vm.answer.ordered
                    ]
                },
                on: {
                  blur: _vm.onBlurOtherField,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.inputStore.question_other[_vm.question.ordered],
                      _vm.answer.ordered,
                      $event.target.value
                    )
                  }
                }
              })
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }